import React, { useState, useRef } from 'react';
import { dateTimeFormat } from './index';
import { FiInfo } from 'react-icons/fi';

const StatusLog = ({t, statusLog}) => {
    const [timeLineCommentID, setTimeLineCommentID] = useState('');
    const ref = useRef();

    return (
        <div className="card-body">
            <div className="slimscroll" style={{ overflowX: 'auto'}}>
                <div className="activity mt-5">
                    {(statusLog?.length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : statusLog?.map(({ createdTime, message, comments }, index) => {
                        return(
                            <div className="activity-info" key={index}>
                                <div className="icon-info-activity">
                                    <i className="fst-normal las la-check-circle bg-soft-primary">{index + 1}</i>
                                </div>
                                <div className="activity-info-text">
                                    <div className="d-flex flex-column align-items-start">
                                        <div className="d-flex">
                                            <p className="d-flex align-items-center badge badge-soft-primary">{message}</p>
                                            <div className="position-relative ms-2">
                                                {(timeLineCommentID === index) && <div ref={ref} className="popover position-absolute fade show bs-popover-start" style={{top: '-60px', width: '300px', left: '-125px'}}>
                                                        <p className="m-0 p-3 popover-body" dangerouslySetInnerHTML={{__html: comments}} />
                                                </div>}
                                                <FiInfo className="c-pointer font-20 me-lg-2" onClick={() => setTimeLineCommentID((timeLineCommentID === index) ? '' : index)} />
                                            </div>
                                        </div>
                                        <p className="text-muted font-11 mt-1">{dateTimeFormat(createdTime)}</p>
                                    </div>
                                </div>
                            </div>   
                        )}
                    )}
                </div>
            </div>
        </div>
    )
}

export default StatusLog;